import React, {Component, useEffect} from 'react';
import  Apiurl from '../ConstURL'
import {Button, Form, Input, message, Card} from 'antd';
import {useNavigate} from "react-router-dom";
import {useAuth} from "../funcs/Authcontext";





export default function  Authpage (){
    const Navigate = useNavigate()

    const {user, loginUser} = useAuth()

    // render() {
    useEffect(()=>{
        try {
            if(user){
                Navigate("/")
            }
        }catch (err){

        }


    },[]);
        const onFinish = (values) => {
            console.log(values)
            fetch(Apiurl+"/user/auth?username="+values.username+"&pass="+values.password)
                .then(response => {
                    return response.json()

                }).then(data => {
                    console.log(data)
                    if(data['Status']){
                        localStorage.setItem("token",data['Data'])
                        localStorage.setItem("userid",data['Id'])
                        message.success("Авторизация прошла успешно!")
                        loginUser()
                        localStorage.setItem("currentpage","Main")
                        Navigate("/main")

                        console.log('Success:', values.username);
                    }else {
                        message.error("Неверный логин или пароль!")
                    }
                }

            )

            //window.alert("Авторизация прошла успешно!")
        };

        const onFinishFailed = (errorInfo) => {
            //console.log('Failed:', errorInfo);
        };
        return(
            <div className="login-bg">
            <Card type="flex" justify="center" align="middle"
                  style={{margin:"20px", minWidth:340, maxWidth:380, width:"100%", borderRadius:18, border:"1px solid #2a2140"}}
                  styles={{body:{padding:32}}}>
              <div style={{textAlign:"center", marginBottom:24}}>
                  <div style={{
                      width:56, height:56, borderRadius:16, margin:"0 auto 14px",
                      background:"linear-gradient(135deg, #a017ff 0%, #6a00cc 100%)",
                      display:"flex", alignItems:"center", justifyContent:"center",
                      fontWeight:800, fontSize:22, color:"#fff",
                      boxShadow:"0 6px 20px rgba(160,23,255,0.5)",
                  }}>ZA</div>
                  <div style={{fontSize:20, fontWeight:700, color:"#fff"}}>Amazon Reports</div>
                  <div style={{color:"rgba(255,255,255,0.45)", fontSize:13}}>Вход в панель аналитики</div>
              </div>
              <Form

                  name="basic"
                  layout="vertical"
                  style={{
                      verticalAlign: 'middle',
                      maxWidth: "70vw",
                  }}
                  initialValues={{
                      remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
              >
                  <Form.Item
                      label="Логин"
                      name="username"
                      rules={[
                          {
                              required: true,
                              message: 'Введите ваш логин!',
                          },
                      ]}
                  >
                      <Input />
                  </Form.Item>

                  <Form.Item
                      label="Пароль"
                      name="password"
                      rules={[
                          {
                              required: true,
                              message: 'Введите ваш пароль!',
                          },
                      ]}
                  >
                      <Input.Password />
                  </Form.Item>



                  <Form.Item style={{marginBottom:0, marginTop:8}}>
                      <Button type="primary" htmlType="submit" size="large" block>
                          Авторизоваться
                      </Button>
                  </Form.Item>
              </Form>
            </Card>
            </div>
        );
    // }
}